
export enum LoginPrompt {
  NONE = 'none',  // peek (just checking for sso)
  LOGIN = 'login', // force login credentials to be provided
  PROMPT = '' // prompt, use sso if available, otherwise prompt for login
}

export default LoginPrompt;
